import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Proforma } from 'src/app/pages/sales/proforma/proforma.model';

@Injectable({
  providedIn: 'root'
})
export class ProformaModalService {

  private selectedProformaSubject = new BehaviorSubject<Proforma | null>(null);
  public selectedProforma$ = this.selectedProformaSubject.asObservable();

  constructor() { }

  setSelectedProforma(proforma: Proforma): void {
    this.selectedProformaSubject.next(proforma);
  }

  getSelectedProforma(): Proforma | null {
    return this.selectedProformaSubject.value;
  }

  clearSelectedProforma(): void {
    this.selectedProformaSubject.next(null);
  }
}
